

export function getComponentOptions(vnode) {
    return vnode.componentOptions.Ctor.options;
}